import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import Wrapper from '../../../../wrapper/wrapper'
import Container from '../../../../container/container'
import Description from '../../../../description/description'
import Footer from '../../../../footer/footer'
import Button from 'pobble-components/dist/button'
import { FIRST_SESSION } from 'pobble-components/dist/cookies'
import EVENTS from '../../../../../events'
import { FSUupsellWithDiscount } from './fsu-upsell/fsu-upsell-with-discount'
import { FSUSchools } from './fsu-upsell/fsu-schools'
import { FSUParents } from './fsu-upsell/fsu-parents'
import { useSubscriptionDetails } from 'pobble-components/dist/subscriptions/utils'

const styles = ({ FONT_SIZES, COLORS }) => ({
  wrapper: {
    width: '100vw',
    marginTop: '-132px',
    '@media (max-width: 575px)': {
      marginTop: '-102px'
    }
  },
  container: {
    maxWidth: '1200px',
    background: '#fff',
    padding: '20px 20px 0',
    margin: '0 auto'
  },
  title: {
    ...FONT_SIZES.HEADING_EXTRA_LARGE.STYLE,
    margin: '24px 0 0',
    textAlign: 'center',
    color: COLORS.PURPLE.NORMAL
  },
  pitch: {
    textAlign: 'center',
    '& p': {
      ...FONT_SIZES.BODY_LARGE.STYLE,
      margin: '8px 0 32px'
    }
  },
  free: {
    textAlign: 'center',
    margin: '24px auto',
    '& button': {
      ...FONT_SIZES.HEADING_MEDIUM.STYLE
    }
  },
  fsuWrapper: {
    padding: '25px',
    maxWidth: '600px',
    textAlign: 'center'
  },
  fsuWrapperCards: {
    padding: '25px',
    maxWidth: '860px',
    textAlign: 'center',
    margin: '0 auto'
  },
  fsuWrapperMax: {
    maxWidth: '1060px',
    textAlign: 'center',
    padding: '25px'
  }
})

const Finished = ({ classes, onGoToPobble, me }) => {
  useEffect(() => {
    FIRST_SESSION.set(true, {
      expires: 1 / 24
    })
  }, [])

  const {
    offerFreeTrial,
    isInPobbleSchool,
    hasAccessToPH
  } = useSubscriptionDetails()

  const isSchoolRepresentative =
    me.account.role_in_life === 'school_administrator' ||
    me.account.role_in_life === 'english_leader_in_school'

  const isStudentRole = me.account.role_in_life === 'student'
  const isParentRole = me.account.role_in_life === 'parent'

  useEffect(() => {
    EVENTS.onAfterFinishSignup()
  }, [])

  if (
    !isStudentRole &&
    !isParentRole &&
    offerFreeTrial &&
    !isInPobbleSchool &&
    !isSchoolRepresentative
  ) {
    return (
      <div className={classes.fsuWrapperCards}>
        <FSUupsellWithDiscount onGoToPobble={onGoToPobble} />
      </div>
    )
  }

  if (isParentRole && !hasAccessToPH) {
    return (
      <div className={classes.fsuWrapperMax}>
        <FSUParents />
      </div>
    )
  }

  if (isSchoolRepresentative) {
    return (
      <div className={classes.fsuWrapper}>
        <FSUSchools onGoToPobble={onGoToPobble} />
      </div>
    )
  }

  return (
    <Wrapper>
      <Container noHead>
        <Description first noBorder title="Thanks for signing up!">
          <p>Your account is now complete.</p>
        </Description>
        <Footer dense>
          <Button
            darkBlue
            wide
            tall
            action={onGoToPobble}
            className={'metrics__go-to-pobble'}>
            Go to Pobble
          </Button>
        </Footer>
      </Container>
    </Wrapper>
  )
}

export default injectSheet(styles)(Finished)
